import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivityGroup } from '@shared/models/activity-group/activity-group';
import { SupplierGroupSummary } from '@shared/models/supplier-groups/supplier-group-summary';
import { LeasingCompanyPartsReductionCreate } from '@app/leasing-company/activity-group-reductions/shared/activity-group-reductions.service';

export type ActivityGroupFormGroup = {
  activityGroup: FormControl<ActivityGroup | null>;
}

export type GroupReductionFormGroup = {
  supplierGroup: FormControl<SupplierGroupSummary | null>;
  partsReductionPercentage: FormControl<string | null>;
}

@Injectable()
export class ActivityGroupReductionAddFormService {
  public readonly activityGroupForm = new FormGroup<ActivityGroupFormGroup>({
    activityGroup: new FormControl(null, [Validators.required])
  });

  public readonly groupReductionForm = new FormGroup<GroupReductionFormGroup>({
    supplierGroup: new FormControl(null, [Validators.required]),
    partsReductionPercentage: new FormControl(
      null,
      [Validators.required, Validators.min(0.00), Validators.max(100.00)]
    )
  });

  public getLeasingCompanyPartsReduction(): LeasingCompanyPartsReductionCreate {
    const { activityGroup } = this.activityGroupForm.getRawValue();
    const { supplierGroup, partsReductionPercentage } = this.groupReductionForm.getRawValue();

    return {
      activityGroup: { code: activityGroup!.code, description: activityGroup!.description },
      supplierGroup: { code: supplierGroup!.code, description: supplierGroup!.description },
      partsReductionPercentage: Number(partsReductionPercentage)
    };
  }
}
